import JwtDecode from 'jwt-decode'

const notificationMessage = (message, onClick) => {
  const notification = new Notification(message)
  // TODO : onClick 에 처리해야 될꺼 있음 추가
  // notification.onclick = onClick;

  notification.onclick = () => {
    notification.close()
  }
}

/**
 * 로그인 토큰에 있는 유저 정보를 decode
 * @returns {any} : JSON 형태의 decode 된 정보
 */
const parseLoginToken = () => {
  var token = localStorage.getItem('token')
  return token ? JSON.parse(JwtDecode(token).details) : null
}

const getSenderUid = () => {
  let uid = localStorage.getItem('sid') || ''
  return uid
}

const setSenderUid = (sid) => {
  localStorage.setItem('sid', sid)
}

const getLoginIdParam = () => {
  return localStorage.getItem('LOGIN_PARAM') || null
}

const setLoginIdParam = (loginId) => {
  localStorage.setItem('LOGIN_PARAM', loginId)
}

// 채널명에 따른 아이콘 반환
const getChatRoomIcon = (moduleChannelName) => {
  if (moduleChannelName === 'WEB_CHAT') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v2.png'
  } else if (moduleChannelName === 'NAVER_TALK') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_naver_talktalk.png'
  } else if (moduleChannelName === 'KAKAO_TALK') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_kakaotalk.png'
  } else if (moduleChannelName === 'SCENARIO') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_chatbot_v2.png'
  } else if (moduleChannelName === 'FACEBOOK_TALK') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_fb_msg.png'
  } else if (moduleChannelName === 'MAIL') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_mail.png'
  } else if (moduleChannelName === 'LINE') {
    return 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/LINE_logo.png'
  } else if (moduleChannelName === 'LINE_PAY') {
    return 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/icon_linepay.png'
  } else if (moduleChannelName === 'PAYPAY') {
    return 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/icon_paypay.png'
  } else {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v1.png'
  }
}

const getChannelIcon = (moduleChannelName) => {
  if (moduleChannelName === 'ウェブチャット') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v2.png'
  } else if (moduleChannelName === 'ネイバートーク') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_naver_talktalk.png'
  } else if (moduleChannelName === 'カカオトーク') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_kakaotalk.png'
  } else if (moduleChannelName === 'チャットボット') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_chatbot_v2.png'
  } else if (moduleChannelName === 'Facebook') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_fb_msg.png'
  } else if (moduleChannelName === 'メール') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_mail.png'
  } else if (moduleChannelName === 'LINE') {
    return 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/LINE_logo.png'
  } else {
    return ''
  }
}

const getCounselorIcon = (moduleChannelName) => {
  if (moduleChannelName === 'WEB_CHAT') {
    // return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-icon.png'
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-talk2-icon.png'
  } else if (moduleChannelName === 'NAVER_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/naver-icon.png'
  } else if (moduleChannelName === 'KAKAO_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/kakao-icon.png'
  } else if (moduleChannelName === 'FACEBOOK_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/facebook-icon.png'
  } else if (moduleChannelName === 'MAIL') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/mail-icon.png'
  } else if (moduleChannelName === 'LINE') {
    return '//public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/LINE_logo.png'
  } else {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-icon.png'
  }
}

const getUserBrandId = () => {
  return parseLoginToken().agentMappingBrandViews[0].brandId
}

// 모바일 여부 확인
const isMobile = () => {
  return !!(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i))
}

// Delete ToPath:KEY
const pathReplace = (arr, path, eject) => {
  if (path !== '/client/claim_information/create' && path !== '/client/claim_information/update') {
    Object.keys(arr).forEach((k) => {
      if (arr[k] && k !== eject) {
        path = path.replace(`/${arr[k]}`, '')
      }
    })
  }
  return path
}

const mergeObject = (target, source) => {
  let obj = target
  for (let key in source) {
    obj[key] = source[key]
  }

  return obj
}

export default {
  getChannelIcon,
  notificationMessage,
  parseLoginToken,
  getSenderUid,
  setSenderUid,
  getLoginIdParam,
  setLoginIdParam,
  getChatRoomIcon,
  getCounselorIcon,
  getUserBrandId,
  isMobile,
  pathReplace,
  mergeObject
}



// WEBPACK FOOTER //
// ./src/util/index.js